import React from 'react';
import PropTypes from 'prop-types';

import { Alert } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';

import AddControl from 'components/add_control/v2';
import CalculationModeFormGroup from './calculation_mode_form_group';
import CohortFormGroup from './cohort_form_group';
import FormTier from './tier';
import ManagedFormGroup from 'components/form/managed_input/form_group';
import ResetPeriodFormGroup from './reset_period_form_group';
import StartDateFormGroup from './start_date_form_group';
import { formatTiers, isReadOnly } from './helpers';

class CommissionPlanForm extends React.Component {
  static propTypes = {
    allowCohorts: PropTypes.bool,
    enabledRealCalculationModes: PropTypes.arrayOf(PropTypes.string),
    plan: PropTypes.shape({
      archived: PropTypes.bool,
      name: PropTypes.string,
      tiers: PropTypes.array.isRequired
    }).isRequired,
    onChange: PropTypes.func.isRequired,
  }

  get readOnly() {
    return isReadOnly(this.props.plan);
  }

  handleAddTier = () => {
    const tiers = [...this.props.plan.tiers];

    if (tiers.length > 0) {
      tiers.push({ ...tiers.pop(), to: 0 });
    }

    tiers.push({ brokerSplit: 0 });

    this.props.onChange({ tiers });
  }

  handleTierChange = (tier, index) => {
    const tiers = [...this.props.plan.tiers];
    tiers[index] = tier;
    this.props.onChange({ tiers });
  }

  render() {
    return (
      <div className="d-flex flex-column gap-3">
        {this.renderReadOnlyWarning()}

        <div>
          {this.renderNameInput()}

          <ResetPeriodFormGroup
            disabled={this.readOnly}
            plan={this.props.plan}
            onChange={this.props.onChange}
          />

          <StartDateFormGroup
            disabled={this.readOnly}
            plan={this.props.plan}
            onChange={this.props.onChange}
          />

          <CalculationModeFormGroup
            disabled={this.readOnly}
            enabledRealCalculationModes={this.props.enabledRealCalculationModes}
            plan={this.props.plan}
            onChange={this.props.onChange}
          />

          <CohortFormGroup
            allowCohorts={this.props.allowCohorts}
            disabled={this.readOnly}
            plan={this.props.plan}
            onChange={this.props.onChange}
          />
        </div>

        <h6>Commission Tiers</h6>
        {this.renderTiers()}

        {!this.readOnly &&
          <AddControl
            className="align-self-end"
            label="Add tier"
            name="add-tier"
            onClick={this.handleAddTier}
          />
        }
      </div>
    );
  }

  renderNameInput() {
    return (
      <ManagedFormGroup
        disabled={this.props.plan.archived}
        label="Name"
        name="name"
        required
        value={this.props.plan.name}
        onChange={this.props.onChange}
      />
    );
  }

  renderTiers() {
    return (
      <div className="table-container">
        <table className="table table-bordered table-form table-form--fixed">
          <thead>
            <tr>
              <th className="text-end">From</th>
              <th className="text-end">To</th>
              <th className="text-end">Broker Split %</th>
            </tr>
          </thead>

          <tbody>
            {formatTiers(this.props.plan.tiers).map((tier, i) => (
              <FormTier
                index={i}
                key={i}
                readOnly={this.readOnly}
                tier={tier}
                unlimited={i === this.props.plan.tiers.length - 1}
                onChange={this.handleTierChange}
              />
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  renderReadOnlyWarning() {
    if (this.readOnly && !this.props.plan.archived) {
      return (
        <Alert className="d-flex align-items-center gap-2" variant="warning">
          <FontAwesomeIcon className="text-warning" icon={faExclamationTriangle} />
          The commission plan has already been used for payments and some of the information cannot be edited.
        </Alert>
      );
    }
  }
}

export default CommissionPlanForm;
